<template>
  <div id="loginPage">
    <div id="login">
      <h3 class="text-center pt-5 text-info">Login Form</h3>
      <div class="container">
        <div id="login-row" class="row justify-content-center align-items-center">
          <div id="login-column" class="col-md-6">
            <div id="login-box" class="col-md-12">
              <form id="login-form" class="form" v-on:submit.prevent="loginPost">
                <h3 class="text-center text-info">Login</h3>
                <div class="form-group">
                  <label for="username" class="text-info">Email:</label>
                  <br />
                  <input
                    type="text"
                    name="username"
                    id="username"
                    class="form-control"
                    v-model="loginEmail"
                  />
                </div>
                <div class="form-group">
                  <label for="password" class="text-info">Password:</label>
                  <br />
                  <input
                    type="password"
                    name="password"
                    id="password"
                    class="form-control"
                    v-model="loginPassword"
                  />
                </div>
                <div class="form-group" id='bottomLogin'>
                  <input type="submit" name="submit" class="btn btn-info btn-md" value="submit" />
                  <a class="text-info" v-on:click="register()">Register Here</a>
   
                </div>
              </form>
                  <button
                    v-google-signin-button="clientId"
                    class="google-signin-button"
                  ><img src="https://img.icons8.com/plasticine/2x/google-logo.png" style="width:15px"></button>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleLogin from "vue-google-login";
export default {
  name: "LogIn",
  data() {
    return {
      loginEmail: "",
      loginPassword: "",
      clientId:
        "889972388488-jg95pij3aijcpthhc1jm20c833r5eune.apps.googleusercontent.com"
    };
  },
  components: {
    GoogleLogin
  },
  methods: {
    loginPost() {
      let payload = {
        email: this.loginEmail,
        password: this.loginPassword
      };
      this.$emit("loginPost", payload);
    },
    register() {
      this.$emit("register");
    },
    OnGoogleAuthSuccess(idToken) {
      //   console.log(idToken);
      // Receive the idToken and make your magic with the backend
      let payload = {
        idToken
      };
      this.$emit("OnGoogleAuthSuccess", payload);
    },
    OnGoogleAuthFail(error) {
      console.log(error);
    }
  }
};
</script>

<style>
.google-signin-button {
  color: white;
  background-color: white;
  height: 20px;
  font-size: 16px;
  border-radius: 5px;
  padding: 10px 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  display: flex;
  align-items: center;
}
#bottomLogin{
    display: flex;
align-items: center;
}

</style>